<template>
  <div>
    <div v-if="errors.length">
      <d-alert
        class="mb-0"
        v-for="error in errors"
        :key="error"
        theme="danger"
        show
        dismissible
        >{{ error }}</d-alert
      >
    </div>
    <div class="main-content-container container-fluid px-4">
      <!-- Page Header -->
      <div class="page-header row no-gutters pt-4 pb-2">
        <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Mes demandes</span>
          <!-- <h3 class="page-title">Traitement des demandes</h3> -->
        </div>
      </div>
      <div class="row flex pb-2">
        <div class="col-12">
          <h5 class="float-left font-weight-bold mb-0">
            Demande
            <span v-if="request.type === 'DAYS_OFF'"> de Congés</span>
            <span v-else-if="request.type === 'SIMPLE_ABSENCE'">
              d'Absence temporaire</span
            >
            <span v-else-if="request.type === 'RECOVERY_TIME_REQUEST'">
              de Declaration d'heures supp</span
            >
            <span v-else-if="request.type === 'RECOVERY_REQUEST'">
              d'Utilisation d'heures supp</span
            >

            | {{ request.lastName }} {{ request.firstName }}
          </h5>
          <button
            v-if="validateDays && !answered"
            :disabled="disabled"
            class="btn btn-primary wizard-btn next-btn float-right"
            @click="confirmRequest()"
          >
            {{ $t("global.submit") }}
          </button>
          <button class="float-right planing-btn" @click="goToPlaning()">
            {{ $t("days.off.request.planingBtn") }}
          </button>
          <button
            v-if="request.type === 'RECOVERY_TIME_REQUEST'"
            class="float-right planing-btn"
            @click="goToDailyReport()"
          >
            {{ $t("recovery.time.request.daily-report.btn") }}
          </button>
        </div>
      </div>

      <div class="mb-4 pb-5">
        <spinner-dot v-if="loading" />
        <template v-else>
          <!-- Activity Items -->
          <div class="card mb-4">
            <div class="card-body p-4">
              <div class="row">
                <div
                  v-bind:class="
                    request.model.comments == undefined &&
                    request.model.reason == undefined &&
                    request.model.motifUrgent == undefined &&
                    request.model.motifOther == undefined
                      ? 'col-md-12'
                      : 'col-md-6'
                  "
                >
                  <template v-if="request.type === 'DAYS_OFF'">
                    <recapitulatif-days-off
                      :request="formattedRequestDaysOff"
                      :show-last-two="true"
                      :all="true"
                    />
                  </template>
                  <template v-else-if="request.type === 'SIMPLE_ABSENCE'">
                    <recapitulatif-simple-absence
                      :request="request"
                      title="Absence temporaire demandée pour:"
                    />
                  </template>
                  <template v-else>
                    <recapitulatif-simple-absence
                      :request="request"
                      title="Declaration/recuperation d'heures supp pour:"
                    />
                  </template>
                </div>
                <div class="col-md-6 reason">
                  <div
                    class="px-md-2"
                    v-if="
                      request.type != 'SIMPLE_ABSENCE' &&
                        request.type != 'DAYS_OFF'
                    "
                  >
                    <div v-if="request.model.comments">
                      <h6>Explication</h6>
                      <p>{{ request.model.comments }}</p>
                    </div>
                  </div>

                  <div
                    class="px-md-2"
                    v-else-if="request.type === 'SIMPLE_ABSENCE'"
                  >
                    <div v-if="request.model.reason">
                      <h6>Motif</h6>
                      <p>{{ request.model.reason }}</p>
                    </div>
                  </div>

                  <div class="px-md-2" v-else>
                    <div v-if="request.model.motifUrgent">
                      <h6>Motif d'urgence</h6>
                      <p>{{ request.model.motifUrgent }}</p>
                    </div>

                    <div v-if="request.model.motifOther">
                      <h6>Autre type de congés</h6>
                      <p>{{ request.model.motifOther }}</p>
                    </div>
                  </div>

                  <!-- <div class="mt-2">
                    <div class="px-2" v-if="request.type === 'DAYS_OFF'">
                      <div class="form-group" v-if="isAccounting()">
                        <div class="d-flex align-items-baseline">
                          <label for="days"><h6 style="color: #b6000a">{{ $t("days.off.request.total.days.off") }} </h6> </label>
                          <input :disabled="answered" class="form-control w-25 mr-3 ml-3" type="number" id="days" v-model="request.model.totalDaysOff" name="days" step="0.5" min="0.5" @input="checkDays">
                          <span> jour(s)</span>
                        </div>
                      </div>
                    </div>
                  </div>-->
                </div>
              </div>
            </div>
            <div class="card-footer light-bg">
              <div v-if="validateDays">
                <div class="row flex align-items-center" v-if="!answered">
                  <div class="col-lg-4">
                    <p class="m-0">
                      {{ $t("global.ask.approval.disapproval") }}
                    </p>
                  </div>
                  <div class="col-lg-4">
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        class="custom-control-input"
                        @click="answer = true"
                        type="radio"
                        v-model="answer"
                        id="approve"
                        :value="true"
                      />
                      <label class="custom-control-label" for="approve">
                        {{ $t("global.approve") }}
                      </label>
                    </div>
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        class="custom-control-input"
                        @click="answer = false"
                        type="radio"
                        v-model="answer"
                        id="disapprove"
                        :value="false"
                      />
                      <label class="custom-control-label" for="disapprove">
                        {{ $t("global.disapprove") }}
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-4" v-if="request.type === 'DAYS_OFF'">
                    <div class="approve" v-if="isAccounting()">
                      <p class="m-0 pr-2">
                        {{ $t("days.off.request.total.days.off") }}
                      </p>
                      <div class="form-group m-0">
                        <input
                          type="text"
                          style="width: 150px"
                          placeholder="nombre de jours"
                          :disabled="answered"
                          v-model="numberOfDaysInput"
                          class="form-control"
                        />
                      </div>
                      <p class="m-0 pl-2">jours</p>
                    </div>
                  </div>
                  <div class="col-lg-7 pt-2" v-if="!answer">
                    <div class="form-group">
                      <textarea
                        class="form-control"
                        v-model="motif"
                        :placeholder="$t('global.explain.reason.disapproval')"
                        cols="50"
                        rows="10"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <h6>{{ $t("days.off.request.already.answered") }}</h6>
                </div>
              </div>
              <div v-else>
                <h6>{{ $t("days.off.request.accountant.permission") }}</h6>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="header-data-table">
                  <h5 class="header-data-table__heading">
                    Statut de la demande
                  </h5>
                </div>
                <div class="table-responsive pb-3">
                  <table class="custom-table table t-responsive">
                    <thead class="t-header-color">
                      <tr class="text-center">
                        <th>Suivi</th>
                        <th>
                          {{ $t("user.firstname") }} {{ $t("user.lastname") }}
                        </th>
                        <th>Statut</th>
                        <th>Date</th>
                        <th>Motif</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(answer, idx) in request.answers" :key="idx">
                        <template
                          v-if="answer.groupReference === GroupsEnum.IN_CHARGE"
                        >
                          <td>N+{{ answer.position }}</td>
                        </template>
                        <template
                          v-if="
                            answer.groupReference === GroupsEnum.SUPER_ADMIN
                          "
                        >
                          <td>Direction</td>
                        </template>
                        <template
                          v-if="answer.groupReference === GroupsEnum.COMPTA"
                        >
                          <td>Comptable</td>
                        </template>
                        <td>{{ answer.firstName }} {{ answer.lastName }}</td>
                        <td v-if="answer.status === 'ACCEPTED'">
                          <button class="status-pill-approved">
                            <span>{{ $t("global.approved") }}</span>
                          </button>
                        </td>
                        <td v-else-if="answer.status === 'PENDING'">
                          <button class="status-pill-pending">
                            <span>{{ $t("global.pending") }}</span>
                          </button>
                        </td>
                        <td v-else-if="answer.status === 'REFUSED'">
                          <button class="status-pill-rejected">
                            <span>{{ $t("global.rejected") }}</span>
                          </button>
                        </td>
                        <td>
                          {{
                            answer.date &&
                            (answer.groupReference === "_compta" ||
                              answer.groupReference === "_super_admin")
                              ? formatDate(answer.date)
                              : ""
                          }}
                        </td>
                        <td>{{ answer.motif ? answer.motif : "" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="d-flex justify-content-between mt-4 ml-3 mr-3">
            <button class="btn btn-outline-secondary" @click="showHistory = !showHistory"><i class="fa fa-clock"></i> {{ $t("global.history") }}</button>
            <div v-if="!answered">
              <button class="btn btn-danger mr-2" @click="refuseModal = true">{{ $t('global.refuse') }}</button>
              <button class="btn btn-success" @click="confirmRequest(true)">{{ $t('global.accept') }}</button>
            </div>
            <div v-else>
              <h6>{{ $t("days.off.request.already.answered") }}</h6>
            </div>
          </div>-->
          <div class="mt-3">
            <template v-if="request.type === 'DAYS_OFF'">
              <history-days-off />
            </template>
            <template v-else-if="request.type === 'SIMPLE_ABSENCE'">
              <history-simple-absence />
            </template>
            <template v-else-if="request.type === 'RECOVERY_TIME_REQUEST'">
              <history-recovery-time />
            </template>
            <template v-else-if="request.type === 'RECOVERY_REQUEST'">
              <history-recovery-request />
            </template>
          </div>
        </template>
      </div>

      <modal :showing="refuseModal" :large="false">
        <d-card-header class="border-bottom">
          <h6 class="m-0">Motif du refus</h6>
          <div class="closeFeature" @click="closeModal"></div>
        </d-card-header>
        <d-card-body>
          <div class="p-4">
            <h5 style="color: #b6000a">
              {{ $t("days.off.request.step.two.motif") }}
            </h5>
            <textarea
              class="form-control mt-4"
              v-model="motif"
              cols="50"
              rows="10"
            ></textarea>
          </div>
        </d-card-body>
        <d-card-footer>
          <div class="d-flex justify-content-between">
            <button class="btn btn-danger" @click="closeModal">
              {{ $t("global.return") }}
            </button>
            <button class="btn btn-success" @click="confirmRequest(false)">
              {{ $t("global.save") }}
            </button>
          </div>
        </d-card-footer>
      </modal>
    </div>
  </div>
</template>

<script>
import { isAccounting } from "../../utils/Rules.js";
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import TimeUtils from "../../utils/TimeUtils";
import daysOffType from "../../data/daysOff/daysOffType.js";
import GroupsEnum from "../../data/groups/GroupsEnum";
import Modal from "../../components/layout/Modal/Modal";
import RecapitulatifDaysOff from "../../components/daysOffRequest/RecapitulatifDaysOff";
import RecapitulatifSimpleAbsence from "../../components/daysOffRequest/RecapitulatifSimple";

export default {
  name: "Answer",
  components: {
    HistoryRecoveryRequest: () =>
      import("../../components/abscenceRequest/HistoryRecoveryRequest"),
    HistoryRecoveryTime: () =>
      import("../../components/abscenceRequest/HistoryRecoveryTime"),
    HistorySimpleAbsence: () =>
      import("../../components/abscenceRequest/HistorySimpleAbsence"),
    HistoryDaysOff: () =>
      import("../../components/abscenceRequest/HistoryDaysOff"),
    RecapitulatifSimpleAbsence,
    RecapitulatifDaysOff,
    Modal,
    SpinnerDot
  },
  data() {
    return {
      reference: null,
      loading: true,
      request: null,
      refuseModal: false,
      showHistory: false,
      answered: false,
      daysOffType,
      GroupsEnum,
      motif: null,
      answer: true,
      errors: [],
      numberOfDaysInput : ''
    };
  },
  watch : {
      numberOfDaysInput(val){
        this.request.model.totalDaysOff=val

      }
  },
  mounted() {
    this.reference = this.$route.params.reference;
    this.$services.absenceRequest
      .findByReference(this.reference)
      .then(({ data }) => {
        this.request = data;
        /* this.fetchUser("5-4423", null, null)
          .then(res => {
            console.log(res);
          })
          .catch(err => console.log(err)); */

        if (this.request.authorized.indexOf(this.user.reference) === -1) {
          this.$router.push("/permission-denied");
        }
        this.alreadyAnswered();
        this.loading = false;
      });
  },
  computed: {
    disabled(){
      const {permissions} =this.$store.state.user.informations
      const isCompta=permissions.filter(perm=>perm.groupReference==="_compta").length > 0
      const checkNumber=Number(this.numberOfDaysInput)
      return isCompta && (this.numberOfDaysInput==="" || isNaN(checkNumber) )
      
        
    },
    type() {
          console.log(this.request)
      return this.request.type;
    },
    user() {
      return this.$store.state.user.informations;
    },
    validateDays() {
      let flag = true;
      this.user.permissions.forEach(p => {
        if (
          p.groupReference == "_super_admin" &&
          this.request.type == "DAYS_OFF"
        ) {
          // flag = this.request.model.validateDays || false;
          flag = true;

        }
      });
      return flag;
    },
    formattedRequestDaysOff() {
      return {
        urgent: this.request.model.urgent,
        type: this.request.model.type,
        dateFrom: this.request.dates[0].from,
        dateTo: this.request.dates[0].to,
        dateFromHalf: TimeUtils.isFullDay(this.request.dates[0].from) - 1,
        dateToHalf: TimeUtils.isFullDay(this.request.dates[0].to) - 1,
        motifOther: this.request.model.motifOther,
        motifUrgent: this.request.model.motifUrgent,
        totalDaysOff: this.request.model.totalDaysOff,
        leftPaidVacations: this.request.model.leftPaidVacations
      };
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return "N/A";
      return TimeUtils.formatDate(date);
    },
    formatTime(date) {
      if (!date) return "N/A";
      return TimeUtils.formatTime(date);
    },
    isAccounting() {
      return isAccounting(this.user);
    },
    checkDays() {
      this.error = false;
      const decimal = (this.days - Math.floor(this.days)) * 10;
      if (decimal !== 0 && decimal !== 5) {
        this.days = 0;
        this.error = true;
      }
    },
    alreadyAnswered() {
      const a = this.request.answers.find(
        answer => answer.userReference === this.user.reference
      );
      if (a.status !== "PENDING") {
        this.answered = true;
      }
    },
    closeModal() {
      this.refuseModal = false;
    },
    confirmRequest() {

      this.loading = true;
      const model = {
        status: this.answer ? "ACCEPTED" : "REFUSED",
        userReference: this.user.reference,
        motif: this.motif,
        
      };
      if (this.isAccounting() && this.request.type === "DAYS_OFF") {
        if (this.request.model.totalDaysOff) {
          model.totalDaysOff = this.request.model.totalDaysOff;
        } else if (!this.request.model.totalDaysOff) {
          this.errors.push(
            "Merci de bien vouloir insérer le nombre de jours que l'employé a prit."
          );
          this.loading = false;
          return;
        }
      }
      this.$services.absenceRequest
        .confirmRequest(this.request.reference, model)
        .then(({ data }) => {
          this.request = data;
          this.alreadyAnswered();
          this.loading = false;
          this.$miniToastr.success("Votre réponse a bien été enregistrée.");
        })
        .catch(() => (this.loading = false));
    },
    fetchUser(ref, include, embed) {
      this.$services.user
        .findByReference(ref, { params: { include, embed } })
        .then(({ data }) => {})
        .catch(error => console.log(error));
    },
    goToPlaning() {
      const end = TimeUtils.formatDateForCalander(this.request.dates[0].from);
      const d = new Date(end);
      d.setDate(d.getDate() + 7);
      const leaveData = {
        flag: false,
        start: TimeUtils.formatDateForCalander(this.request.dates[0].from),
        end: TimeUtils.formatDateString(d)
      };
      this.$store.dispatch("fillLeaveData", leaveData);
      this.$router.push("/attendance");
    },

    goToDailyReport() {
      const d = new Date(
        TimeUtils.formatDateForDailyReport(this.request.dates[0].to)
      );
      const to_date = d.toLocaleDateString();
      d.setDate(d.getDate() + 1);
      const from_date = d.toLocaleDateString();
      const appCreds = {
        to: to_date,
        from: from_date,
        userReference: this.request.userReference
      };
      const userName = `${this.request.firstName} ${this.request.lastName}`;
      this.$services.dailyReport
        .personDailyReport(appCreds, userName)
        .then(res => {
          this.$router.push("/reportCard");
        })
        .catch(error => {
          this.$miniToastr.error("Rien n'a été trouvé.");
        });
    }
  }
};
</script>

<style lang="scss">
.repondre-right-box {
  background-color: rgba(0, 0, 0, 0.05);
  color: #000;
  font-size: 16px;
}
.reason h6 {
  color: #212529;
  font-size: 20px;
  font-family: "SF-Pro-Text";
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
}
.reason p {
  font-size: 14px;
  font-family: "SF-Pro-Text";
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: -0.41px;
}
.margin-mobile {
  @media (max-width: 767px) {
    margin: 30px 0 0 0;
  }
}
.t-header-color {
  background-color: #2571c1;
  tr {
    th {
      border: 0 !important;
      color: #fff;
    }
  }
}
th {
  color: gray;

  &.active {
    color: #007bff;

    .arrow {
      opacity: 1;

      &.asc {
        border-bottom: 4px solid #007bff;
      }

      &.dsc {
        border-top: 4px solid #fff;
      }
    }
  }
}
td {
  text-align: center;
  vertical-align: middle !important;
}
@media (max-width: 576px) {
  .t-responsive {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767px) {
  .reason {
    margin-top: 20px;
  }
}
@media (max-width: 991px) {
  .card-footer.light-bg .row .col-lg-4 {
    margin-bottom: 10px;
  }
  .card-footer.light-bg .row {
    text-align: center;
  }
  .card-footer.light-bg .row .approve {
    display: flex;
    align-items: center;
    justify-content: center;
    float: initial;
  }
  textarea.form-control {
    width: 100% !important;
  }
}
.custom-table thead tr th {
  background-color: #fbfbfb;
  color: #303778;
}
.custom-table tbody tr {
  border-bottom: 1px solid #e9ecef;
}
.card .header-data-table {
  margin-bottom: 0;
  border-bottom: 0;
}
.status-pill-pending {
  border: 1px solid #ffb400;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  padding: 0;
}
.status-pill-pending span {
  display: block;
  width: 100px;
  border-radius: 5px;
  padding: 5px 15px;
  font-weight: 700;
  background-color: rgba(255, 180, 0, 0.24);
  color: #ffb400;
}
.status-pill-approved {
  border: 1px solid #17c671;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  padding: 0;
}
.status-pill-approved span {
  display: block;
  width: 100px;
  border-radius: 5px;
  padding: 5px 15px;
  font-weight: 700;
  background-color: rgba(23, 198, 113, 0.24);
  color: #17c671;
}
.status-pill-rejected {
  border: 1px solid #c4183c;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  padding: 0;
}
.status-pill-rejected span {
  display: block;
  width: 100px;
  border-radius: 5px;
  padding: 5px 15px;
  font-weight: 700;
  background-color: rgba(196, 24, 60, 0.24);
  color: #c4183c;
}
.approve {
  display: flex;
  flex-direction: row;
  align-items: center;
  float: right;
}
.card-footer.light-bg {
  background-color: #f6f8ff;
}
.alert.alert-danger {
  color: #c4183c;
  background-color: #f1c7d0;
}
.next-btn {
  border-radius: 5px !important;
}
textarea.form-control {
  width: 95%;
}
.btn-back {
  background-color: #fff;
  color: #4f78e1;
  border-radius: 8px;
  padding: 10px 30px;
  border: 1px solid #4f78e1;
  i {
    position: relative;
    right: 5px;
  }
}
.planing-btn {
  background-color: #fff;
  border: 1px solid #4f78e1;
  padding: 5px 20px;
  margin-right: 15px;
  color: #4f78e2;
  font-size: 16px;
  text-transform: capitalize;
  border-radius: 4px;
}
</style>
